import {useSyncExternalStore} from 'react';
import {useNavigate} from 'react-router-dom';
import Icon from '../Icon';
import {confirm} from '../../hooks/useConfirm';
import {draftStorage} from '../../lib/draftStorage';
import {draftStore} from '../../lib/newTellDraft';

// On every tab screen: the unfinished forms, each with Continue and Discard, so a draft is
// never invisible and never a trap. The index is synchronous (localStorage), so this paints on
// first render even before IndexedDB has answered.
export const useDraftIndex = () => useSyncExternalStore(draftStorage.subscribe, draftStorage.index, () => []);

export default function DraftBanner() {
    const drafts = useDraftIndex();
    const navigate = useNavigate();
    if (drafts.length === 0) return null;

    const discard = async (key: string, label: string) => {
        if (await confirm({title: 'Discard this draft?', body: label, confirmLabel: 'Discard', destructive: true})) {
            if (key === 'newTell') draftStore.reset();
            else await draftStorage.remove(key);
        }
    };

    return (
        <div className="mb-4 flex flex-col gap-2" role="status">
            {drafts.map(d => (
                <div key={d.key} className="nudge settle-in flex items-center gap-3">
                    <Icon name={d.key === 'newTell' ? 'camera' : 'edit'} size={20} className="shrink-0" />
                    <span className="min-w-0 flex-1">
                        <span className="block">{d.key === 'newTell' ? 'An unfinished tell' : 'Unsaved changes'}</span>
                        <span className="block truncate font-medium">{d.label}</span>
                    </span>
                    <button type="button" className="shrink-0 rounded-sm px-2 py-1 font-display font-bold underline-offset-2 hover:underline" onClick={() => navigate(d.route)}>
                        Continue
                    </button>
                    <button type="button" aria-label="Discard draft" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-pill opacity-70" onClick={() => void discard(d.key, d.label)}>
                        <Icon name="close" size={16} strokeWidth={2.2} />
                    </button>
                </div>
            ))}
        </div>
    );
}
